import Dictionaries from "../Dictionaries.js";

let columns = [
    {
        key: 'id_',
        field: 'id_',
        table:'t_coordinated_transport_cost',
        renderType:Dictionaries.RENDER_TYPE.DISPLAY,
    },
    {
        title: '选择',
        key: '_checked',
        field: '_checked',
        renderType: Dictionaries.RENDER_TYPE.CHECKBOX,
        dynamicPermissions:{
            key: 'flag',
            value: ['1','2','3','4'],
        },
        minWidth:65
    },
    {
        title: '账单状态',
        key: 'flag',
        field: 'flag',
        table: 't_coordinated_transport_cost',
        minWidth: 95,
        renderType: Dictionaries.RENDER_TYPE.SELECT,
        optList:[
            {label:'未付' , value: '0'},
            {label:'部分付' , value: '1'},
            {label:'已付' , value: '3'}],
        editPermissions:Dictionaries.EDIT_PERMISSIONS.READ_ONLY
    },

    {
        //title: '账单状态',
        //key: 'flag',
        // field: 'flag',
        // table: 't_coordinated_transport_bill',
        //minWidth: 95,
        // renderType: Dictionaries.RENDER_TYPE.SELECT,
        // optList:[
        //     {label:'制单' , value: '0'},
        //     {label:'申请' , value: '1'},
        //     {label:'审核' , value: '2'},
        //     {label:'开票' , value: '3'}],
        // default:'制单',
        // editPermissions:Dictionaries.EDIT_PERMISSIONS.READ_ONLY
    },

    {
        title: '费用名称',
        key: 'expense_name',
        field: 'expense_name',
        table: 't_coordinated_transport_cost',
        renderType:Dictionaries.RENDER_TYPE.INPUT,
        dynamicPermissions:{
            key: 'flag',
            value: ['1','2','3','4'],
        },
        minWidth:95,
    },
    {
        title: '货主名称',
        key: '_postal_company',
        field: 'postal_company',
        table: 't_coordinated_transport',
        minWidth:95,
    },
    {
        title: '单价',
        key: 'unit_price',
        field: 'unit_price',
        table: 't_coordinated_transport_cost',
        minWidth:110,
        renderType:Dictionaries.RENDER_TYPE.NUMBER,
        calculator:{
            field:['unit_price','weight'],
            results:"total_amount",
            scheme:Dictionaries.RENDER_TYPE.CALCULATOR.MULTIPLY
        },
        dynamicPermissions:{
            key: 'flag',
            value: ['1','2','3','4'],
        },
    },
    {
        title: '实际数量',
        key: 'weight',
        field: 'weight',
        table: 't_coordinated_transport_cost',
        minWidth:110,
        renderType:Dictionaries.RENDER_TYPE.NUMBER,
        calculator:{
            field:['unit_price','weight'],
            results:"total_amount",
            scheme:Dictionaries.RENDER_TYPE.CALCULATOR.MULTIPLY
        },
        dynamicPermissions:{
            key: 'flag',
            value: ['1','2','3','4'],
        },
    },
    {
        title: '金额',
        key: 'total_amount',
        field: 'total_amount',
        minWidth:110,
        table: 't_coordinated_transport_cost',
    },
    // {
    //     title: '添加时间',
    //     key: 'publisher_time',
    //     field: 'publisher_time',
    //     minWidth:110,
    //     table: 't_coordinated_transport_cost',
    // },
    {
        title: '备注',
        key: 'remarks',
        field: 'remarks',
        minWidth:65,
        table: 't_coordinated_transport_cost',
    },
    {
        title: '操作',
        key: 'action',
        field: 'action',
        renderType:Dictionaries.RENDER_TYPE.ACTION,
        buttonList:[{
            name:"删除",
            field:"flag",
            value:"9999",
            table: "t_coordinated_transport_cost",
            type:"error",
            size:"small",
        }],
        dynamicPermissions:{
            key: 'flag',
            value: ['1','2','3','4'],
        },
    },
]

let from = "t_coordinated_transport_cost"

let link = [
    {
        linkScheme:"LEFT JOIN",
        table:"t_coordinated_transport_cost",
        key:"coordinated_transport_order_id",
        linkedTable:"t_coordinated_transport_order",
        foreignKey:"id_",
    },
    {
        linkScheme:"LEFT JOIN",
        table:"t_coordinated_transport_order",
        key:"coordinated_transport_id",
        linkedTable:"t_coordinated_transport",
        foreignKey:"id_",
    },
    {
        linkScheme:"LEFT JOIN",
        table:"t_coordinated_transport_cost",
        key:"coordinated_transport_bill_id",
        linkedTable:"t_coordinated_transport_bill",
        foreignKey:"id_",
    },

]

let where =[]

const default_where =  [
    {
        label: '状态',
        value: '9999',
        table: from,
        field: 'flag',
        scheme: " != ",
    }
]

let order_by = [{
    table:'t_coordinated_transport_cost',
    key:'publisher_time'
}]

export default {
    columns,
    from,
    link,
    where,
    default_where,
    order_by
}
